
import axios from "axios";
import dayjs from 'dayjs';
import { parseISO,eachDayOfInterval, format } from "date-fns";
import { formatDate, formatDateText } from "../CommonFunctions";

const url=process.env.REACT_APP_SERVER_URL;
export const getAllActiveTenantsInfo= async(e,searchStartDate,searchEndDate)=>{
    try{
        const dateColumnFilter="actualPaymentDate";
        const response = await axios.post(`${url}/payments/allPaymentsinDateRange`,{
            searchStartDate,
            searchEndDate,
            dateColumnFilter
        })
      return response;

    }
    catch(error){
      console.log(error)

    }
}
  
export const getFreeRoomsByDate= async(startDate,endDate) => {
        try{
            console.log(startDate + endDate)
            
            const responseForRooms= await axios.post(`${url}/vacancyCheckByDateRange`,{
            startDate,
            endDate
            })
            if(responseForRooms && responseForRooms.data){
                const response1=await axios.get(`${url}/rooms`);
                if(response1){
                    console.log("in getFreeRoomsByDate")
                const temp=response1.data;
                const rooms=temp.filter(roomId => !roomId.rentable);
                return {data:responseForRooms.data,rooms:rooms};
                }

            }
            return null;
        
        // .then( async(responseForRooms) =>{
        //     console.log(responseForRooms.data);
            
        //     const response1=await axios.get(`${url}/rooms`);
        //     if(response1){
        //         console.log("in getFreeRoomsByDate")
        //       const temp=response1.data;
        //       const rooms=temp.filter(roomId => !roomId.rentable);
              
        //     }
            
        //   })
        }catch(error)
        {
            console.log(error);
        }
      }
      export const getCurrentInventory = async () => {
        try {
          const response=await axios.get(`${url}/getCurrentInventory`);
            if(response)
          return response.data;
        return null;
        } catch (error) {
          console.log(error)
        }
      }
export const getReportSummary =async(e,searchStartDate,searchEndDate)=>{
      try{
        let totalMonthly_lastYear = 0;
          const response_current=await getAllActiveTenantsInfo(null,searchStartDate,searchEndDate);

          let searchStartDate_lastYear=parseISO(searchStartDate);
          searchStartDate_lastYear.setFullYear(searchStartDate_lastYear.getFullYear() - 1); // Subtract 1 from the current year
          searchStartDate_lastYear= formatDate(searchStartDate_lastYear)
          //End Date should be month end, so that I can get data for entire month summarised value.
          let searchEndDate_lastYear = parseISO(searchEndDate);
          searchEndDate_lastYear = new Date(
            searchEndDate_lastYear.getFullYear(), 
            searchEndDate_lastYear.getMonth() + 1, 0);
          
          searchEndDate_lastYear.setFullYear(searchEndDate_lastYear.getFullYear() - 1);
           // Subtract 1 from the current year
           searchEndDate_lastYear= formatDate(searchEndDate_lastYear)
          const response_last=await getAllActiveTenantsInfo(null,searchStartDate_lastYear,searchEndDate_lastYear);
          
          
          if(response_current && response_current.data){
            // console.log("jfbhdddddddddddddddd")
            const resultArray_current = preProcess(response_current.data,searchStartDate,searchEndDate)
            if(response_last && response_last.data){
              const resultArray_last=preProcess(response_last.data,searchStartDate_lastYear,searchEndDate_lastYear);
              const resultArray=[];
              let dict={};
              let temp_lastYear=0;
              for(let itr in resultArray_last){
                dict[resultArray_last[itr].date] = resultArray_last[itr].amount
                temp_lastYear+=resultArray_last[itr].amount

              }
              totalMonthly_lastYear=temp_lastYear
              
              for(let itr in resultArray_current){
                // console.
                resultArray.push({
                  "date": resultArray_current[itr].date,
                  "amount": resultArray_current[itr].amount,
                  "lastYearAmount" : dict[resultArray_last[itr].date] ? dict[resultArray_last[itr].date] : 0
                })
              }
              console.log(resultArray)
              return resultArray
              // setReportSummary(resultArray)
            
            }

          }
          return null;

          
  
      }
      catch(error){
        console.log(error)
  
      }
    }
export const preProcess = (data,searchStartDate,searchEndDate) =>{
      var dictionary={}
      for(let itr in data){
        const currentRow=data[itr];
        if(!(currentRow.actualPaymentDate in dictionary))
        {
          dictionary[currentRow.actualPaymentDate]=0;
        }
        let temp=0;
        if(currentRow.cashAmount!==null){
          temp+=currentRow.cashAmount;
        } 
        if(currentRow.creditCardAmount!==null){
          temp+=currentRow.creditCardAmount;
        } 
        if(currentRow.otherAmount!==null){
          temp+=currentRow.otherAmount;

        }
        dictionary[currentRow.actualPaymentDate] +=temp;
      }
      const interval = {
        start: parseISO(searchStartDate),
        end: parseISO(searchEndDate)
      };
      const dates = eachDayOfInterval(interval).map(date => format(date, 'yyyy-MM-dd'));
      const resultArray=[];
      dates.forEach(date => {
        if(date in dictionary){
            resultArray.push({
              date:formatDateToMonthAndDate(date),
              amount:dictionary[date]
            })
        }
        else{
          resultArray.push({
            date:formatDateToMonthAndDate(date),
            amount:0
          })

        }
        
      });
      
      return resultArray;
    }

    function formatDateToMonthAndDate(inputDate) {
      const date = parseISO(inputDate);
      const options = { month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
  }

  export const getCurrentYearRevenueInDC = async(searchStartDate, searchEndDate) =>{
        try{
          const currentYearStart = formatDate(new Date(new Date().getFullYear(), 0, 1));

          console.log(currentYearStart);
          let totalAnnual = 0;
          let total_lastYear=0;
          const response=await getAllActiveTenantsInfo(null,currentYearStart,searchEndDate);
          const currentYear = new Date().getFullYear();
          const startDate_lastYear = formatDate(new Date(currentYear - 1, 0, 1)); // Jan 1st of last year
          const endDate_lastYear = formatDate(new Date(currentYear - 1, 11, 31)); // Dec 31st of last year
          console.log("startDate_lastYear : " + startDate_lastYear);
          console.log("endDate_lastYear : " + endDate_lastYear);
          const response_lastYear= await getAllActiveTenantsInfo(null,startDate_lastYear,endDate_lastYear);
          // console.log(response)
          if(response && response.data){
            const resultArray=preProcess(response.data,currentYearStart,searchEndDate)
            console.log(resultArray)
            let temp=0;
            let dict={};
              for(let itr in resultArray){
                const currentRow=resultArray[itr];
                const month= resultArray[itr].date.split(' ')[0];
                if(month in dict){
                  dict[month] += currentRow.amount
                }
                else{
                  dict[month] = currentRow.amount
                }
                
                temp+=currentRow.amount;
  
              }
              totalAnnual=temp;
              
              
              if(response_lastYear && response_lastYear.data){
                const resultArray_lastYear=preProcess(response_lastYear.data,startDate_lastYear,endDate_lastYear);
                let dict_lastYear={};
                // console.log(resultArray_lastYear)
                let temp_lastYear=0;
              for(let itr in resultArray_lastYear){
                const currentRow=resultArray_lastYear[itr];
                
                const month= resultArray_lastYear[itr].date.split(' ')[0];
                if(month in dict_lastYear){
                  dict_lastYear[month] += currentRow.amount
                }
                else{
                  dict_lastYear[month] = currentRow.amount
                }
                temp_lastYear += currentRow.amount
  
              }
              total_lastYear = temp_lastYear
              // console.log(dict_lastYear)
  
              let rs=[]
              for(let itr in dict_lastYear){
                rs.push({"month": itr,"amount":dict[itr] ? dict[itr] : 0, 
                  lastYearAmount: dict_lastYear[itr] ? dict_lastYear[itr] : 0})
  
              }
              console.log(rs);
  
              return {resultArray:rs, totalThisYear: totalAnnual,
                totalLastYear: total_lastYear
              }
  
              }
              
          }
          return null;
  
  
        }
        catch(error){
          console.log(error)
    
        }
        
      }

export const getCallLogsByDateRangeInDC = async(searchStartDate, searchEndDate) =>{
  try{
    const response = await axios.post(`${url}/callLogs/byDateRange`,{
      searchStartDate, searchEndDate
    })
    if(response && response.data){
      return response.data;
    }

  }catch(error){
    console.log(error)
    
  }
}

export const categories = {
  plumbing: ['water','leak', 'pipe', 'toilet', 'sink', 'drain', 'clog', 'faucet'],
  electrical: ['light', 'bulb', 'switch', 'outlet', 'power', 'electric', 'fan'],
  appliance: ['fridge', 'microwave', 'oven', 'washer', 'dryer', 'stove', "vent", "ac", 'thermostat','air conditioner', 'heater'],
  general: ['paint', 'door', 'window', 'floor', 'wall', 'lock'],
  others:[]

};

export function categorizeRepair(description) {
  const text = `${description}`.toLowerCase();
  let bestMatch = 'others';
  let maxHits = 0;

  for (const [category, keywords] of Object.entries(categories)) {
    const hits = keywords.filter(keyword => text.includes(keyword)).length;
    if (hits > maxHits) {
      maxHits = hits;
      bestMatch = category;
    }
  }

  return bestMatch;
}

export const getRepairsByDateRangeInDC = async(searchStartDate, searchEndDate)=>{
  try{
    const response = await axios.post(`${url}/repairs/byDateRange`,{
      searchStartDate, searchEndDate
    })
    if(response && response.data){
      return response.data
    }
    return [];

  }catch(error){

  }

}

export const getCallLogsByDateRangeCalculations = async(searchStartDate, searchEndDate) =>{
      try{
        const response = await getCallLogsByDateRangeInDC(searchStartDate, searchEndDate);
        if(response){
          let totalCalls = response.length;
            let resultArray=[];
            let resultDict={}; //1- ModelTraining, 2- afternoon 3- evening 4- night
            resultDict["Morning"]=0;
            resultDict["Afternoon"]=0;
            resultDict["Evening"]=0;resultDict["Night"]=0;
          for(let itr in response){
            // console.log(response[itr].callDate);
            const localDate = new Date(response[itr].callDate);
            // Get local hour
            const localHour = localDate.getHours();
            // Determine the part of day
            if (localHour >= 6 && localHour < 12) {
                resultDict["Morning"]=resultDict["Morning"]+1;
            } else if (localHour >= 12 && localHour < 17) {
                resultDict["Afternoon"]=resultDict["Afternoon"]+1;
            } else if (localHour >= 17 && localHour < 21) {
                resultDict["Evening"]=resultDict["Evening"]+1;
            } else {
                resultDict["Night"]=resultDict["Night"]+1;
            }
          }
          Object.keys(resultDict).forEach((key) => {
            resultArray.push({name: key, value:resultDict[key]})
            });
            return {
              resultArray: resultArray,
              totalCalls: totalCalls
            };
        }
    
      }catch(error){
        console.log(error)
        
      }
 }

 export async function fetchExpectedPaymentsInDC(searchStartDate, searchEndDate) {
  try {
    // Step 1: Make API call
    const { data: checkins } = await axios.post(`${url}/tenants/checkins/dateRange`, {
      searchStartDate,
      searchEndDate
    });

    // Step 2: Initialize a date-keyed dictionary for the full date range
    const dateMap = {};
    let current = dayjs(searchStartDate);
    const end = dayjs(searchEndDate);

    while (current.isBefore(end) || current.isSame(end, 'day')) {
      const dateStr = current.format('YYYY-MM-DD');
      dateMap[dateStr] = 0; // initialize count
      current = current.add(1, 'day');
    }

    // Step 3: Iterate checkins and count expected payments
    checkins.forEach(item => {
      const dateStr = dayjs(item.checkin).format('YYYY-MM-DD');
      if (dateMap.hasOwnProperty(dateStr)) {
        dateMap[dateStr] += 1;
      }
    });

    // Step 4: Convert dictionary to array for chart/table use
    const resultArray = Object.entries(dateMap).map(([date, expectedPayments]) => ({
      date,
      expectedPayments
    }));

    console.log('Expected Payments by Date:', resultArray);
    return resultArray;
  } catch (error) {
    console.error('Error fetching expected payments:', error);
    throw error;
  }
}


/**
 * Fetch received payments for all check-ins in the given date range.
 * 
 * @param {string} searchStartDate - e.g., '2025-10-01'
 * @param {string} searchEndDate - e.g., '2025-10-07'
 * @returns {Promise<Array<{date: string, receivedPayments: number}>>}
 */
export async function fetchReceivedPaymentsInDC(searchStartDate, searchEndDate) {
  try {
    // Step 1: Call backend endpoint with checkin filter
    const { data } = await axios.post(`${url}/payments/allPaymentsinDateRange`, {
      searchStartDate,
      searchEndDate,
      dateColumnFilter: 'checkinDate'
    });
// Step 2: Filter out entries with no actual payment
    const validPayments = data.filter(item => {
      const paid = parseFloat(item.paidAmount || 0);
      return !isNaN(paid) && paid > 0;
    });

    // Step 3: Initialize dictionary for date range
    const dateMap = {};
    let current = dayjs(searchStartDate);
    const end = dayjs(searchEndDate);

    while (current.isBefore(end) || current.isSame(end, 'day')) {
      const dateStr = current.format('YYYY-MM-DD');
      dateMap[dateStr] = new Set(); // store unique tenant IDs
      current = current.add(1, 'day');
    }

    // Step 4: Aggregate tenant IDs who paid on time per date
    validPayments.forEach(item => {
      const checkinDate = dayjs(item.checkin).format('YYYY-MM-DD');
      const tenantId = item.id; // always use tenant id
      if (tenantId && dateMap.hasOwnProperty(checkinDate)) {
        dateMap[checkinDate].add(tenantId);
      }
    });

    // Step 5: Convert dictionary to array format
    const resultArray = Object.entries(dateMap).map(([date, tenantIdSet]) => ({
      date,
      tenantIds: Array.from(tenantIdSet),
      receivedPayments: tenantIdSet.size, // number of tenants paid on time
    }));

    console.log('Tenants Paid On Time by Date:', resultArray);
    return resultArray;
  } catch (error) {
    console.error('Error fetching on-time tenant payments:', error);
    throw error;
  }
}